module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ipadfp"
  }, [_c('img', {
    staticClass: "imagefp",
    attrs: {
      "alt": "Cover: The Future King, by James Riley",
      "aria-describedby": "cover-alt",
      "role": "doc-cover",
      "src": "e9781534425774/images/9781534425774.jpg"
    }
  })]), _vm._v(" "), _c('aside', {
    attrs: {
      "hidden": "hidden",
      "id": "cover-alt"
    }
  }, [_c('p', [_vm._v("Revenge of Magic")]), _vm._v(" "), _c('p', [_vm._v("The Future King")]), _vm._v(" "), _c('p', [_vm._v("James Riley")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("New York Times")]), _vm._v(" Bestselling author of Story Thieves")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-791f002a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781534425774/xhtml/cover.vue
// module id = 54
// module chunks = 0